        // Get the necessary elements using their new, more specific IDs
        const openPopupBtn = document.getElementById('simplePopupTriggerBtn');
        const closePopupBtn = document.getElementById('simplePopupCloseBtn');
        const popupOverlay = document.getElementById('simplePopupOverlay'); // This is the overlay container
        const popupActionBtn = document.getElementById('simplePopupActionBtn');

        // Function to open the popup
        function openPopup() {
            if (popupOverlay) {
                // The 'show' class is still used on the overlay container to control visibility and animation
                popupOverlay.classList.add('show');
            }
        }

        // Function to close the popup
        function closePopup() {
            if (popupOverlay) {
                popupOverlay.classList.remove('show');
            }
        }

        // Event listener for the open button
        if (openPopupBtn) {
            openPopupBtn.addEventListener('click', openPopup);
        }

        // Event listener for the close button
        if (closePopupBtn) {
            closePopupBtn.addEventListener('click', closePopup);
        }
        
        // Event listener for the action button (which also closes the popup)
        if (popupActionBtn) {
            popupActionBtn.addEventListener('click', closePopup);
        }

        // Event listener to close the popup when clicking on the overlay (outside the content)
        if (popupOverlay) {
            popupOverlay.addEventListener('click', function(event) {
                // Check if the click is on the overlay itself (event.target) 
                // and not on any of its children (like the popup content box)
                if (event.target === popupOverlay) {
                    closePopup();
                }
            });
        }

        // Optional: Close popup with the Escape key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && popupOverlay && popupOverlay.classList.contains('show')) {
                closePopup();
            }
        });




        function adjustTrademarkSize(target) {
  let elementsToProcess = [];

  if (typeof target === 'string') {
    // If target is a string, assume it's a selector
    try {
      elementsToProcess = Array.from(document.querySelectorAll(target));
    } catch (e) {
      console.error('Failed to query selector:', target, e);
      return; // Exit if selector is invalid
    }
  } else if (target instanceof Element || target instanceof Node) { // Check for Node as well for text nodes in some cases
    // If target is an element or a node, process it directly
    elementsToProcess = [target];
  } else {
    console.error('Invalid target for adjustTrademarkSize:', target);
    return;
  }

  elementsToProcess.forEach(element => {
    // Only process element nodes directly for child iteration
    if (element.nodeType === Node.ELEMENT_NODE) {
      if (element.childNodes.length > 0) {
        // Convert childNodes to an array before iterating to avoid issues if the DOM changes
        Array.from(element.childNodes).forEach(child => {
          if (child.nodeType === Node.TEXT_NODE) {
            if (child.textContent && child.textContent.includes('™')) {
              const fragment = document.createDocumentFragment();
              child.textContent.split('™').forEach((textPart, index, arr) => {
                fragment.appendChild(document.createTextNode(textPart));
                if (index < arr.length - 1) { // Don't add a TM span after the last part
                  const span = document.createElement('span');
                  span.classList.add('smaller-tm'); // Ensure you have this CSS class defined
                  span.textContent = '™';
                  fragment.appendChild(span);
                }
              });
              // Replace the original text node with the fragment
              child.parentNode.replaceChild(fragment, child);
            }
          } else if (child.nodeType === Node.ELEMENT_NODE && !child.classList.contains('smaller-tm')) {
            // Recursively call for child elements, but not for the spans we just added
            adjustTrademarkSize(child); // Pass the child element directly
          }
        });
      }
    }
    // If the target itself is a text node (less common for initial call but good for robustness)
    else if (element.nodeType === Node.TEXT_NODE) {
        if (element.textContent && element.textContent.includes('™')) {
            const fragment = document.createDocumentFragment();
            element.textContent.split('™').forEach((textPart, index, arr) => {
                fragment.appendChild(document.createTextNode(textPart));
                if (index < arr.length - 1) {
                    const span = document.createElement('span');
                    span.classList.add('smaller-tm');
                    span.textContent = '™';
                    fragment.appendChild(span);
                }
            });
            element.parentNode.replaceChild(fragment, element);
        }
    }
  });
}

// Define the CSS for the smaller trademark symbol
// You can add this to your existing CSS file or in a <style> tag in the <head>
const styleElementForTM = document.createElement('style');
styleElementForTM.textContent = `

`;
document.head.appendChild(styleElementForTM);


// Run the function on the entire body when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  adjustTrademarkSize(document.body); // Start with the body element directly
  // Or target a more specific container if preferred:
  // const mainContent = document.getElementById('main');
  // if (mainContent) {
  //   adjustTrademarkSize(mainContent);
  // }
});


///////////////////////////////////////////
//////////////// NEWSLETTERS //////////////
//////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
  // --- Configuration ---
  // For each trigger, map a desktop and a mobile Klaviyo Form ID.
  const klaviyoTriggers = {
    '#varsity-signup': {
      desktop: 'VasaUX',
      mobile: 'TDneGZ'
    },
    '#apparel-signup': {
      desktop: 'Uq7qVL',
      mobile: 'WKwHDP'
    },
    '#newsletter': {
      desktop: 'XqNN2b',
      mobile: 'RbF6NP'
    },
    '#team-sales': {
      desktop: 'VYdVPT',
      mobile: 'W9AETR'
    }
    // Add new triggers here, following the same format
  };
  // --------------------

  // Get all the keys (the hrefs like '#varsity-signup') from our configuration
  const triggerHrefs = Object.keys(klaviyoTriggers);

  // If there are no triggers defined, don't do anything else
  if (triggerHrefs.length === 0) {
    return;
  }

  // Create a CSS selector to find all links with any of our trigger hrefs
  // It will look like: a[href="#varsity-signup"],a[href="#apparel-signup"],...
  const selector = triggerHrefs.map(href => `a[href="${href}"]`).join(',');

  // Find all links on the page that match our selector
  const triggerLinks = document.querySelectorAll(selector);

  // Loop through each found link
  triggerLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      // Prevent the link from trying to navigate anywhere
      event.preventDefault();

      // Check if the viewport matches mobile dimensions (at the time of the click)
      const isMobile = window.matchMedia('(max-width: 719px)').matches;

      // Get the href of the clicked link (e.g., '#varsity-signup')
      const clickedHref = link.getAttribute('href');

      // Find the corresponding config object from our configuration
      const triggerConfig = klaviyoTriggers[clickedHref];

      // If we have a valid config, choose the form ID based on the device type
      if (triggerConfig) {
        const formId = isMobile ? triggerConfig.mobile : triggerConfig.desktop;
        
        // If a form ID exists for the current device type, trigger the popup
        if (formId) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
          console.log(`Klaviyo form ${formId} triggered by ${clickedHref} on ${isMobile ? 'mobile' : 'desktop'}.`);
        } else {
          console.log(`No ${isMobile ? 'mobile' : 'desktop'} form ID configured for ${clickedHref}.`);
        }
      }
    });
  });
});





document.addEventListener('DOMContentLoaded', function() {
    // Select both parent containers that should be animated
    const animatedSections = document.querySelectorAll('.icon-with-text-columns__columns, .multi-column-items');

    // If neither section is found, do nothing
    if (animatedSections.length === 0) {
        return;
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            // If an observed section is scrolling into view
            if (entry.isIntersecting) {
                // Add the 'in-view' class to it to trigger the CSS animation
                entry.target.classList.add('in-view');
                // Stop observing this section once it has been animated
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1 // Trigger when 10% of the section is visible
    });

    // Tell the observer to watch each of the selected sections
    animatedSections.forEach(section => {
        observer.observe(section);
    });
});
